import React from 'react';
import cx from 'classnames';

const DescriptionBlockView = ({ properties, metadata }) => {
  const data = metadata || properties || {};

  const blockWidth = data?.styles?.blockWidth || 'normal';
  const text = data?.description || '';

  return (
    <div className={cx(`has--blockWidth--${blockWidth}`)}>
      <p className="documentDescription">{text}</p>
    </div>
  );
};

export default DescriptionBlockView;
